import * as R from "ramda";
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink, Redirect } from "react-router-dom";
import API from "../../../../nagamas-web/src/Services/Api";
import AuthAction from "../../Redux/AuthRedux";
import EmployeeAction from "../../Redux/EmployeeRedux";
import ProfileChangePasswordModal from "./ProfileChangePasswordModal";
import ProfileUserProfileModal from "./ProfileUserProfileModal";
// let name = localStorage.getItem("name");

var opActivePopup = "app-small-profile active";
var clActivePopup = "app-small-profile";

var clContentPopup = "app-menu-popup app-menu-popup-hide";

class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileClass: clContentPopup,
      smallProfileClass: clActivePopup,
      auth: props.auth,
      dataEmployee: "",
      eventClose: true,
      changePasswordModalVisible: false,
      userProfileModalVisible: false,
    };
  }

  componentWillReceiveProps(newProps) {
    let jwtToken = localStorage.getItem("token");
    if (R.isNil(jwtToken)) {
      this.logout();
      return;
    }
    let { auth } = newProps;
    this.setState({ auth });
    if (!R.isNil(auth.user)) {
      this.getImage(auth);
      this.getDataEmployee(auth.user.employeeID);
    }
  }

  componentWillMount() {
    let jwtToken = localStorage.getItem("token");
    if (R.isNil(jwtToken)) {
      this.logout();
      return;
    }
    let { auth } = this.state;
    if (!R.isNil(auth.user)) {
      this.getImage(auth);
      this.getDataEmployee(auth.user.employeeID);
    }
  }

  async getDataEmployee(employeeID) {
    let payload = {
      employeeID: employeeID,
    };
    // let res = await API.create('EMPLOYEE_QUERY').getEmployeeById(payload)
    // if (res.ok && res.data.status === 'S') {
    //   this.setState({
    //     dataEmployee:{
    //       PPG:res.data.data.payrollProcessingGroup && !R.isNil(res.data.data.payrollProcessingGroup.bizparValue) ? res.data.data.payrollProcessingGroup.bizparValue : null,
    //       employeeName:this.state.auth.user.employeeName,
    //       positionName:this.state.auth.user.positionName === 'NULL_NONE' ? '-' : this.state.auth.user.positionName,
    //       directorateName:this.state.auth.user.directoratePositionName === 'NULL_NONE' ? '-' : this.state.auth.user.directoratePositionName
    //     }
    //   })
    // }
  }

  async getImage(value) {
    let employeeID = !R.isNil(value.user) ? value.user.employeeID : "";
    //   let response = await fetch(process.env.REACT_APP_HCIS_BE_API + 'emcmd/api/employee.photo.get/' + employeeID, {
    //     headers: {
    //       'Authorization': 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhZG1pbiJ9.5BG9SEVOGo_xRhtT8IkyoSy60kPg8HM9Vpvb0TdNew4'
    //     }
    //   })
    //   response = await response.blob()
    // if (response.size > 0) {
    //   response = URL.createObjectURL(response);
    //   this.setState({ imageUrl: response })
    //   }
  }

  handleClickOutside(element) {
    // console.log(element)
    const outsideclickListener = (event) => {
      if (!element.contains(event.target)) {
        element.style.display = "none";
        removeClickListener();
      }
    };

    const removeClickListener = () => {
      this.setState({ smallProfileClass: clActivePopup, eventClose: true });
      document.removeEventListener("click", outsideclickListener);
    };

    document.addEventListener("click", outsideclickListener);
  }

  opProfile = () => {
    var element = document.getElementById("app-profile");
    element.style.display = "block";
    this.setState({
      smallProfileClass: opActivePopup,
      eventClose: !this.state.eventClose,
    });
    if (this.state.eventClose) {
      this.handleClickOutside(element);
    }
    // if (this.state.profileClass === clContentPopup) {
    //   this.setState({ profileClass: opContentPopup })
    //   this.setState({ smallProfileClass: opActivePopup })
    // } else {
    //   this.setState({ profileClass: clContentPopup })
    //   this.setState({ smallProfileClass: clActivePopup })
    // }
  };

  logout() {
    let payload = {
      logoutLocationLongitude: 0,
      logoutLocationLatitude: 0,
    };
    API.create("AUTHLOG").logout(payload);
    localStorage.clear("name");
    localStorage.clear("token");
    localStorage.clear("persist:primary");
    localStorage.clear("userId");

    this.props.authLogout();
  }

  handleUserProfileModalVisibility = () => {
    this.setState({
      userProfileModalVisible: !this.state.userProfileModalVisible,
    });
  };

  handleChangePasswordModalVisibility = () => {
    this.setState({
      changePasswordModalVisible: !this.state.changePasswordModalVisible,
    });
  };

  render() {
    // let name = localStorage.getItem("name");
    let jwtToken = localStorage.getItem("token");
    if (R.isNil(jwtToken)) return <Redirect to={{ pathname: "/" }}></Redirect>;
    const { idUser, username } = this.props.auth.user;

    return (
      <div>
        <div
          onClick={this.opProfile}
          className={this.state.smallProfileClass}
          style={{ float: "right" }}
        >
          <div className="asp-col-1">
            <div className="image image-circle image-30px background-transaparant">
              {this.state.imageUrl === undefined ? (
                <i
                  className="fa fa-user"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: 5,
                  }}
                />
              ) : (
                <img src={this.state.imageUrl} alt="" />
              )}
            </div>
          </div>
          <div className="asp-col-2">
            <div className="ttl">
              <i className="fa fa-lw fa-angle-down txt-site txt-primary txt-16" />
            </div>
            {/*<div className="ttl">
              <div className="txt-site txt-main txt-12 txt-cap">
              	Admin
              </div>
            </div>*/}
          </div>
        </div>

        <div
          style={{ top: "45px", width: "250px" }}
          id="app-profile"
          className={this.state.profileClass}
        >
          <ul>
            {/* <NavLink to="/ess/personnel"> */}
            {/* <li> */}
            {/* <div style={{ fontWeight: "bold" }}> */}
            {/* <i className="icn fa fa-lw fa-user"></i> {`${this.state.dataEmployee.employeeName}${R.isNil(this.state.dataEmployee.PPG) ? '' : `(${this.state.dataEmployee.PPG})`}`}<br/><br/> */}
            {/* <i className="icn fa fa-lw fa-user"></i>
                  {name}
                </div> */}
            {/* <div>
                  {this.state.dataEmployee.positionName}<br/>
                  {this.state.dataEmployee.directorateName}
                </div> */}
            {/* <span className='txt-site txt-main txt-thin txt-11'>{'See your profile'}</span> */}
            {/* </li> */}
            {/* </NavLink> */}
            {/* <li style={{fontWeight:'bold'}}>
              {`${this.state.dataEmployee.employeeName}${R.isNil(this.state.dataEmployee.PPG) ? '' : `(${this.state.dataEmployee.PPG})`}`}
            </li> */}
            <button
              id="btn_open_user_profile_modal"
              onClick={this.handleUserProfileModalVisibility}
              style={{
                background: "none",
                cursor: "pointer",
                textAlign: "left",
                width: "100%",
              }}
            >
              <li>
                <i className="icn fa fa-lw fa-user"></i>
                User Profile
              </li>
            </button>
            <button
              id="btn_open_change_password_modal"
              onClick={this.handleChangePasswordModalVisibility}
              style={{
                background: "none",
                cursor: "pointer",
                textAlign: "left",
                width: "100%",
              }}
            >
              <li>
                <i className="icn fa fa-lw fa-lock"></i>
                Change Password
              </li>
            </button>
            <NavLink to="/">
              <li onClick={this.logout.bind(this)}>
                <i className="icn fa fa-lw fa-power-off"></i>
                Logout
              </li>
            </NavLink>
          </ul>
        </div>
        <ProfileUserProfileModal
          username={idUser}
          visible={this.state.userProfileModalVisible}
          onClickClose={this.handleUserProfileModalVisibility}
        />
        <ProfileChangePasswordModal
          username={idUser}
          visible={this.state.changePasswordModalVisible}
          onClickClose={this.handleChangePasswordModalVisibility}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    employee: state.employee,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authLogout: () => dispatch(AuthAction.authLogout()),
    getEmployeeName: (obj) => dispatch(EmployeeAction.getEmployeeName(obj)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Pages);
